module.exports = __webpack_public_path__ + "img/plus.5c80ff89.svg";